import { useEffect, useState } from "react"
import { CommaFire } from "../CommaFire"

export declare type InputProps = {
    name?: string,
    title?: string,
    placeholder: string,
    errorMessage?: string,
    custom_class?: string,
    checked?: boolean,
    onChange?: (e: any) => any;
    children?: JSX.Element | JSX.Element[],
    defaultValue?: any,
    border?: boolean,
    required?:boolean ,
    deisable?:boolean ,
}

export const CSelect = ({ onChange, children, defaultValue, placeholder, border, title ,name , required , deisable }: InputProps) => {

    const handelOnchange = (e: any) => {
        onChange?.(e)
    }

    return (
        <>
            <div className={` flex relative px-[7px] h-full rounded-[5px] items-center mb-[3px] transition-all ${border && 'border border-dayan-gray-100 focus-within:border-2 focus-within:border-dayan-orange-50'}`}>
                {title &&
                    <span className="text-[12px] text-dayan-gray-100 absolute bg-white top-[-12px] right-[15px] px-[10px] ">{title}</span>
                }
                <select name={name ? name :''} defaultValue={defaultValue} className={` w-full h-full bg-transparent px-[10px] sm:text-[13px] text-[11px] focus:outline-none  ${deisable && 'cursor-not-allowed'} `} onChange={(e: any) => handelOnchange(e)} required={required ? required : false} disabled={deisable ? deisable : false} >
                    {(!defaultValue || defaultValue != "") &&
                        <option  value={''} selected disabled hidden>{placeholder}</option>
                    }
                    {children}
                </select>
            </div>
        </>
    );
}